var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "squadra-tavolo", class: _vm.squadraClass },
    [
      _vm.isCardVariant && _vm.haScelto_
        ? _c("div", { staticClass: "cyan haScelto white--text" }, [
            _vm._v("Ha scelto"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCardVariant && _vm.staScegliendo_
        ? _c("div", { staticClass: "cyan staScegliendo white--text" }, [
            _vm._v("\n    Sta scegliendo\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCardVariant && _vm.isVincente && _vm.mostraVincente
        ? _c("crediti", {
            staticClass: "offerta offerta-vincente",
            attrs: { crediti: _vm.offerta, variant: "dark", glow: "" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: { eager: "", absolute: "", disabled: _vm.disableMenu },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                return [
                  _c("div", _vm._g({}, on), [
                    _vm.isLineVariant
                      ? _c("div", { staticClass: "content-line" }, [
                          _c(
                            "div",
                            { staticClass: "line-avatar" },
                            [
                              _vm.pic
                                ? _c("img", { attrs: { src: _vm.pic } })
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "line-avatar-placeholder",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("person")]
                                  ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "stato line-presence",
                                class: _vm.presenceClass,
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "line-info" }, [
                            _c("div", { staticClass: "line-title" }, [
                              _c("div", { staticClass: "line-name" }, [
                                _vm._v(_vm._s(_vm.squadra_.name)),
                              ]),
                              _vm._v(" "),
                              _vm.staScegliendo_ || _vm.haScelto_
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "line-status cyan darken-2 white--text",
                                    },
                                    [
                                      _vm.staScegliendo_
                                        ? _c("span", [_vm._v("Sta scegliendo")])
                                        : _c("span", [_vm._v("Ha scelto")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.lineInactiveReason
                                ? _c(
                                    "div",
                                    { staticClass: "line-inactive-reason" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.lineInactiveReason) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.showLineCrediti || _vm.showLineMaxOfferta
                              ? _c("div", { staticClass: "line-meta" }, [
                                  _c(
                                    "div",
                                    { staticClass: "crediti-wrapper" },
                                    [
                                      _vm.showLineCrediti
                                        ? _c("crediti", {
                                            attrs: { crediti: _vm.crediti },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showLineMaxOfferta
                                        ? _c(
                                            "div",
                                            { staticClass: "offerta-max" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "label" },
                                                [_vm._v("Max")]
                                              ),
                                              _vm._v(" "),
                                              _c("animate-number", {
                                                attrs: {
                                                  number: _vm.maxOfferta,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "line-actions" },
                            [
                              _vm.isSpeaker_
                                ? _c("div", { staticClass: "line-countdown" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.timeLeft != null
                                            ? _vm.timeLeft
                                            : 0
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isVincente && _vm.mostraVincente
                                ? _c("crediti", {
                                    staticClass:
                                      "line-offerta offerta-vincente",
                                    attrs: {
                                      crediti: _vm.offerta,
                                      variant: "dark",
                                      glow: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showLineMaxOffertaBar
                            ? _c("div", { staticClass: "line-bars" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "line-bar line-bar-max-offerta",
                                    attrs: { title: "Offerta massima" },
                                  },
                                  [
                                    _c("span", {
                                      style: {
                                        width: _vm.lineMaxOffertaRatio + "%",
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _c("div", { staticClass: "content" }, [
                          _c("div", { staticClass: "left-part" }, [
                            _vm.pic
                              ? _c("img", { attrs: { src: _vm.pic } })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isSpeaker_
                              ? _c("div", { staticClass: "countdown" }, [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.timeLeft != null ? _vm.timeLeft : 0
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "details" },
                            [
                              _c("div", { staticClass: "nome" }, [
                                _vm._v(_vm._s(_vm.squadra_.name)),
                              ]),
                              _vm._v(" "),
                              _c("ruoli-completati", {
                                attrs: { id_squadra: _vm.id },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "crediti-wrapper" },
                                [
                                  _c("crediti", {
                                    attrs: { crediti: _vm.crediti },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "offerta-max" },
                                    [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v("Max"),
                                      ]),
                                      _vm._v(" "),
                                      _c("animate-number", {
                                        attrs: { number: _vm.maxOfferta },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "stato",
                            class: _vm.presenceClass,
                          }),
                        ]),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _vm.showMostraRosa
                ? _c(
                    "v-list-item",
                    { on: { click: _vm.mostraRosa } },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "text--text",
                              attrs: { small: "", left: "" },
                            },
                            [_vm._v("admin_panel_settings")]
                          ),
                          _vm._v("Mostra rosa"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  attrs: { disabled: _vm.forzaPassoDisabled },
                  on: { click: _vm.forzaPasso },
                },
                [
                  _c(
                    "v-list-item-title",
                    { staticClass: "error--text" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "error--text",
                          attrs: { small: "", left: "" },
                        },
                        [_vm._v("airline_stops")]
                      ),
                      _vm._v("Forza\n          'Passo'"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.squadra_.active == 1
                ? _c(
                    "v-list-item",
                    {
                      attrs: { disabled: _vm.setActiveDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.setActive(0)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "error--text" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "error--text",
                              attrs: { small: "", left: "" },
                            },
                            [_vm._v("person_remove")]
                          ),
                          _vm._v("Escludi temporaneamente"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.squadra_.active == 0
                ? _c(
                    "v-list-item",
                    {
                      attrs: { disabled: _vm.setActiveDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.setActive(1)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("person_add"),
                          ]),
                          _vm._v("Riammetti\n          all'asta"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.Config.STANDALONE
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.promptEditCreditiSquadra(_vm.id)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "text--text",
                              attrs: { small: "", left: "" },
                            },
                            [_vm._v("mode_edit")]
                          ),
                          _vm._v("Modifica\n          crediti"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list-item",
                { on: { click: _vm.showAstaOrder } },
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "text--text",
                          attrs: { left: "", small: "" },
                        },
                        [_vm._v("settings_backup_restore")]
                      ),
                      _vm._v("\n          Ordine partecipanti"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                { on: { click: _vm.promptChangeAdmin } },
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "text--text",
                          attrs: { left: "", small: "" },
                        },
                        [_vm._v("engineering")]
                      ),
                      _vm._v(" "),
                      _vm.adminUid == _vm.squadra_.id
                        ? _c("span", [_vm._v("Rimuovi da Amministratore")])
                        : _c("span", [_vm._v("Rendi Amministratore")]),
                      _vm._v(" "),
                      _c(
                        "small",
                        {
                          staticClass:
                            "d-inline-block error white--text ml-1 px-1 rounded",
                        },
                        [_vm._v("NEW")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.Config.STANDALONE
                ? _c(
                    "v-list-item",
                    {
                      attrs: {
                        disabled: !!_vm.eliminaSquadraReason,
                        title: _vm.eliminaSquadraReason,
                      },
                      on: { click: _vm.showEliminaSquadra },
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            { staticClass: "error--text" },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    left: "",
                                    small: "",
                                    color: "error",
                                  },
                                },
                                [_vm._v("delete_forever")]
                              ),
                              _vm._v(
                                "\n            Elimina squadra definitivamente\n          "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.eliminaSquadraReason
                            ? _c(
                                "v-list-item-subtitle",
                                { staticClass: "text-wrap" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.eliminaSquadraReason) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showLayoutMenu
                ? [
                    _c("v-divider", { staticClass: "mb-2" }),
                    _vm._v(" "),
                    _c(
                      "v-list-item",
                      [_c("v-list-item-title", [_vm._v("Layout")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "ml-2",
                            attrs: { dense: "", mandatory: "", borderless: "" },
                            model: {
                              value: _vm.tavoloLayoutModel,
                              callback: function ($$v) {
                                _vm.tavoloLayoutModel = $$v
                              },
                              expression: "tavoloLayoutModel",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.TAVOLO_LAYOUT.CERCHIO,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.colorSpeedDial,
                                    attrs: { small: "" },
                                  },
                                  [_vm._v("lens")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.TAVOLO_LAYOUT.GRIGLIA,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("view_module"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-list-item-title"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.tavoloLayoutModel ==
                              _vm.Constants.TAVOLO_LAYOUT.CERCHIO,
                            expression:
                              "tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO",
                          },
                        ],
                      },
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "progressive-sizes ml-2",
                            attrs: { dense: "", mandatory: "", borderless: "" },
                            model: {
                              value: _vm.tavoloSizeModel,
                              callback: function ($$v) {
                                _vm.tavoloSizeModel = $$v
                              },
                              expression: "tavoloSizeModel",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.TAVOLO_SIZE.SMALL,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("lens"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.TAVOLO_SIZE.MEDIUM,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("lens"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.TAVOLO_SIZE.LARGE,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("lens"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-list-item-title"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "progressive-sizes ml-2",
                            attrs: { dense: "", mandatory: "", borderless: "" },
                            model: {
                              value: _vm.squadreSizeModel,
                              callback: function ($$v) {
                                _vm.squadreSizeModel = $$v
                              },
                              expression: "squadreSizeModel",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.SQUADRE_SIZE.SMALL,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("account_box"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.SQUADRE_SIZE.MEDIUM,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("account_box"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                class: _vm.bgSpeedDial,
                                attrs: {
                                  value: _vm.Constants.SQUADRE_SIZE.LARGE,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("v-icon", { class: _vm.colorSpeedDial }, [
                                  _vm._v("account_box"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-list-item-title"),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }